import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

import Card1 from 'src/assets/images/carousel-icons/card1.png';
import Card2 from 'src/assets/images/carousel-icons/card2.png';
import Card3 from 'src/assets/images/carousel-icons/card3.png';
import Card4 from 'src/assets/images/carousel-icons/card4.png';
import Card5 from 'src/assets/images/carousel-icons/card5.png';
import Card6 from 'src/assets/images/carousel-icons/card6.png';

import { Flex, Text } from 'src/components/common';
import { ChevronLeftIcon, ChevronRightIcon } from 'src/components/icons/ui-icons';
import { theme } from 'src/theme';
import { useTranslation } from 'react-i18next';

interface CardItem {
  icon: any;
  text: string;
}

const SliderWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  margin-bottom: 32px;
  justify-content: center;
  align-items: center;
  padding-left: 200px;
  padding-right: 200px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding-left: 0px;
    padding-right: 0px;
  }

  .slick-slider {
    width: 100%;
    margin-top: 16px;
    margin-bottom: 64px;

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      padding: 20px;
    }

    .slick-dots {
      margin: 32px 0 0 0;
      display: flex !important;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: unset !important;
      left: 50%;
      transform: translateX(-50%);

      li {
        position: relative;
        display: flex;
        width: auto;
        height: auto;
        margin: 0 5px;
        padding: 0;
        cursor: pointer;

        button {
          width: 6.6px;
          height: 6.6px;
          background: rgba(0, 0, 0, 0.33);
          padding: unset !important;
          border-radius: 10px;

          &::before {
            display: none;
          }
        }

        &.slick-active {
          button {
            width: 13px !important;
            height: 13px !important;
            background: ${theme.colors.palette.darkPurple} !important;
          }
        }
      }
    }

    .slick-arrow.slick-next,
    .slick-arrow.slick-prev {
      cursor: pointer;

      * {
        cursor: pointer;
      }
    }

    .slick-list {
      display: flex;
    }

    .slick-track {
      display: flex;
      gap: 40px;

      @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        gap: unset;
      }
    }

    .slick-slide {
      display: flex;
      align-items: stretch;
      justify-content: center;

      > div:first-of-type {
        width: 100% !important;
      }
    }
  }
`;

const PrevArrowWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 50%;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    display: none;

    * {
      display: none;
    }
  }
`;

const NextArrowWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  right: 0;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    display: none;

    * {
      display: none;
    }
  }
`;

function NextArrow(props: any) {
  const { className, style, onClick } = props;

  return (
    <NextArrowWrapper onClick={onClick} style={style}>
      <ChevronRightIcon className={className} color={theme.colors.palette.darkPurple} />
    </NextArrowWrapper>
  );
}

function PrevArrow(props: any) {
  const { className, style, onClick } = props;

  return (
    <PrevArrowWrapper onClick={onClick} style={style}>
      <ChevronLeftIcon className={className} color={theme.colors.palette.darkPurple} />
    </PrevArrowWrapper>
  );
}

const sliderSettings = {
  dots: true,
  draggable: false,
  infinite: true,
  swipeToSlide: true,
  lazyLoad: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      },
    },
  ],
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

export const HomeCarousel = () => {
  const { t } = useTranslation();

  const cards: CardItem[] = [
    { icon: Card1, text: t('home_7') },
    { icon: Card2, text: t('home_8') },
    { icon: Card3, text: t('home_9') },
    { icon: Card4, text: t('home_10') },
    { icon: Card5, text: t('home_11') },
    { icon: Card6, text: t('home_12') },
  ];

  const renderCards = () => {
    return cards.map((item, index) => (
      <Flex key={index} flexDirection={'column'} width={'100%'} height={'100%'}>
        <img src={item.icon} alt="icon" width={'100%'} height={'auto'} />
        <Text variant="paragraph1" text={item.text} width={'100%'} margin="16px 0 0 0" textAlign="center" />
      </Flex>
    ));
  };

  return (
    <SliderWrapper>
      <Slider {...sliderSettings}>{renderCards()}</Slider>
    </SliderWrapper>
  );
};
